module.exports = __webpack_public_path__ + "img/in.13f09060.png";